import {useMutation, useQueryClient} from '@tanstack/react-query';
import {closeChat, markChatAsRead, createMessageApi, fetchOperatorsAfterTime, transferChatApi} from './chat-api';

/* ---------------------- MARK AS READ ---------------------- */
export const useMarkChatAsRead = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: markChatAsRead,
        onSuccess: (_, id) => {
            // لیست چت‌ها ریفرش بشه (badge unread و ... آپدیت شه)
            queryClient.invalidateQueries({queryKey: ['chats']});
            // در صورت داشتن کش تک‌چت
            const key = ['chat', id];
            const cached = queryClient.getQueryData(key);
            if (cached) {
                queryClient.setQueryData(key, {
                    ...cached,
                    data: {
                        ...(cached.data || cached),
                        unread: false,
                    },
                });
            }
            onSuccess?.();
        },
    });
};

/* ---------------------- CLOSE CHAT ---------------------- */
export const useCloseChat = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: closeChat,
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({queryKey: ['chats']});
            const key = ['chat', id];
            const cached = queryClient.getQueryData(key);
            if (cached) {
                queryClient.setQueryData(key, {
                    ...cached,
                    data: {
                        ...(cached.data || cached),
                        // مطابق ChatStates بک‌اند؛ 'CLOSED' وجود خارجی ندارد.
                        state: 'OPERATOR_FINISHED',
                    },
                });
            }
            onSuccess?.();
        },
    });
};

export const useCreateMessage = (onSuccess) => {
    return useMutation({
        mutationFn: createMessageApi,
        onSuccess: (data) => {
            if (onSuccess) onSuccess(data);
        },
    });
};

export const useOperatorsAfterTime = () =>
    useMutation({
        mutationFn: fetchOperatorsAfterTime,
    });


export const useTransferChat = (onSuccess) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({chatId, operatorId}) =>
            transferChatApi(chatId, operatorId),

        onSuccess: (_, {chatId, operatorId}) => {
            queryClient.invalidateQueries({queryKey: ['chats']});

            const key = ['chat', chatId];
            const cached = queryClient.getQueryData(key);

            if (cached) {
                queryClient.setQueryData(key, {
                    ...cached,
                    data: {
                        ...(cached.data || cached),
                        operatorId,
                    },
                });
            }

            onSuccess?.();
        },
    });
};